import listOrganisationDevices from "../../requests/devices/listOrganisationDevices";
var ListOrganisationDevicesCommand = /** @class */ (function () {
    function ListOrganisationDevicesCommand() {
        // console.log('ListOrganisationDevicesCommand');
        this.then = this.then.bind(this);
    }
    /**
     * @param deviceCollection DeviceCollection
     *
     * @return {*}
     */
    ListOrganisationDevicesCommand.prototype.execute = function (deviceCollection) {
        this.deviceCollection = deviceCollection;
        return listOrganisationDevices().then(this.then);
    };
    /**
     *
     * @param response
     */
    ListOrganisationDevicesCommand.prototype.then = function (response) {
        // console.log('ListOrganisationDevicesCommand data', response);
        this.deviceCollection.reset();
        this.deviceCollection.addAll(response);
    };
    return ListOrganisationDevicesCommand;
}());
export default ListOrganisationDevicesCommand;
